import React, { useState, useEffect, useCallback } from 'react'
import { useSnackbar } from 'notistack'
import DynamicTable from '../../components/DataTables/DynamicTable'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import Spiner from '../../components/General/Spiner'
import FormModal from '../../components/General/FormModal'
import { styled } from '@mui/material/styles'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const  Grupos = () => {
  const [isOpenModalform, setIsOpenModalForm] = useState(false)
  const [dataTableroForm, setDataTableroForm] = useState([])
  const { enqueueSnackbar } = useSnackbar()
  const [saveType, setSaveType] = useState('I')
  const [header, setHeader] = useState('I')
  const [groupId, setGroupId] = useState(0)
  const [spiner, setSpiner] = useState(false)
  const [data, setdata] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const getGroup = useCallback(async (idGroup, page, perPage, search = "") => {
    setSpiner(true)
    const resp = await ConfiguracionLogic.grupoLogic(idGroup, page, perPage, search)
    if (resp.success) {
      setdata(resp.data)
      setTotalRows(resp.totalRows)
    }
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setSpiner(false)
  }, [enqueueSnackbar]);

  useEffect(() => {
    getGroup(0, 1, 10, '')
  }, [getGroup])

  const columns = ['Nombre', 'Descripción', 'Creación'] // Ajusta esto según tus necesidades

  // Funciones para manejar las acciones de los botones
  const handleNew = async () => {
    cleanStorage()
    setSaveType("I")
    setGroupId(0)
    setSpiner(true)
    setDataTableroForm([])
    setIsOpenModalForm(true)
    setSpiner(false)
    setHeader('Nuevo Grupo')
  }

  const handleDelete = (item) => {
    setSelectedItem(item)
    setOpenDeleteModal(true)
  }

  const confirmDelete = async () => {
    if (selectedItem) {
      setSpiner(true)
      //const resp = await ConfiguracionLogic.usuariosSeguridadesBiLogic(selectedItem.id, selectedItem, "D")
      const resp = await ConfiguracionLogic.saveEditGroupLogic(selectedItem.id, selectedItem, "D")
      enqueueSnackbar(resp.message, {
        variant: resp.variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      })
      if (resp.success) {
        window.location.reload()
      }
      setSpiner(false)
      setOpenDeleteModal(false)
    }
  }

  const cancelDelete = () => {
    setOpenDeleteModal(false)
  }

  const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '20px',
    marginLeft: theme.spacing(4),
    padding: theme.spacing(1, 4),
  }))

  const handlePageChange = (page, perPage) => {
    getGroup(0, page, perPage, '')
  }

  const handleSearch = (item) => {
    getGroup(0, 1, 10, item)
  }

  const handledSave = async (event) => {
    event.preventDefault()
    setSpiner(true)
    const resp = await ConfiguracionLogic.saveEditGroupLogic(groupId, event.target, saveType)
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setSpiner(false)
    if (saveType === 'I') {
      if (resp.success) {
        setIsOpenModalForm(false)
        cleanStorage()
      }
      setTimeout(function () {
        if (resp.success) {
          window.location = global.GRUPOS_CREATE
        }
      }, global.DELAY)
    } else {
      setIsOpenModalForm(false)
      //const resp = await ConfiguracionLogic.grupoLogic(groupId, 1, 5, '')
      //setDataTableroForm(resp)
      window.location.reload();
    }
  }

  const handleEdit = async (item) => {
    setSpiner(true)
    const resp = await ConfiguracionLogic.grupoLogic(item.id, 1, 5, '')
    setSaveType("E")
    setGroupId(item.id)
    setDataTableroForm(resp)
    setIsOpenModalForm(true)
    setSpiner(false)
    setHeader('Editar grupo')
  }

  const cleanStorage = () => {
    localStorage.removeItem('idemEmpre')
    localStorage.removeItem('rucEmp')
    localStorage.removeItem('codIdEmp')
    localStorage.removeItem('nombEmp')
    localStorage.removeItem('sigEmp')
    localStorage.removeItem('activEmp')
    localStorage.removeItem('groupEmp')
  }

  const handleCloseModal = () => {
    setIsOpenModalForm(false)
    cleanStorage()
  }

  return (

    <div className="content-wrapper">
      <Spiner opt={spiner} />
      <FormModal
        isOpen={isOpenModalform}
        handleCloseModal={handleCloseModal}
        header={header}
        button={'Guardar'}
        formData={dataTableroForm}
        handledSave={handledSave}
        opt={'grupo'}
        modalWith={'md'} // Puedes ajustar a 'xs', 'sm', 'lg', 'xl' según lo que necesites
      />
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Configuración</li>
                <li className="breadcrumb-item">Grupos</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <br />
                <div className="card-body">
                  <DynamicTable
                    columns={columns}
                    data={data}
                    onNew={handleNew}
                    headerText="Nuevo grupo"
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    onSearch={handleSearch}
                    onPageChange={handlePageChange}
                    totalRows={totalRows}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Dialog
        open={openDeleteModal}
        onClose={cancelDelete}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialogContent-root": {
            overflowY: "hidden", // Esto evitará la barra de desplazamiento
          },
          "& .MuiDialog-paper": {
            maxHeight: "400px", // Ajusta el tamaño máximo del modal si es necesario
          },
        }}
      >
        <DialogTitle>
          Confirmar Eliminación
          <IconButton
            edge="end"
            color="inherit"
            onClick={cancelDelete}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <p>¿Estás seguro que deseas eliminar este elemento?</p>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={cancelDelete} sx={{ backgroundColor: 'lightblue', color: 'blue', '&:hover': { backgroundColor: 'lightblue' } }}>
            Cancelar
          </StyledButton>
          <StyledButton onClick={confirmDelete} sx={{ backgroundColor: 'blue', color: 'white', '&:hover': { backgroundColor: 'darkblue' } }}>
            Confirmar
          </StyledButton>
        </DialogActions>
      </Dialog>

    </div>
  )
}

export default Grupos
